export enum FeatureFlagName {
  BUILD_ORDER_BUTTON = 'BUILD_ORDER_BUTTON',
  BUILD_QUOTE_BUTTON = 'BUILD_QUOTE_BUTTON',
  COVER_COMMAND_CENTER = 'COVER_COMMAND_CENTER',
  COVER_STOP_OUTREACH_WHEN_COVERED = 'COVER_STOP_OUTREACH_WHEN_COVERED',
  DEPRECATE_USER_ALLOW_LISTS = 'DEPRECATE_USER_ALLOW_LISTS',
  DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD',
  MCLEOD_DOCUMENT_UPLOAD = 'MCLEOD_DOCUMENT_UPLOAD',
  LOAD_SHIPMENT_BY_ID = 'LOAD_SHIPMENT_BY_ID',
  ORDER_PRESUBMIT_VALIDATION = 'ORDER_PRESUBMIT_VALIDATION',
  PAUSE_MESSAGE_CLASSIFICATION = 'PAUSE_MESSAGE_CLASSIFICATION',
  QUOTE_UPDATE_FROM_TMS_IMPORT = 'QUOTE_UPDATE_FROM_TMS_IMPORT',
  QUOTES_CONDITIONAL_AUTO_REPLY = 'QUOTES_CONDITIONAL_AUTO_REPLY',
  SCHEDULING = 'SCHEDULING',
  TRACK_LOADS_IN_SIDEKICK = 'TRACK_LOADS_IN_SIDEKICK',
  VIEW_CALLS_BUTTON = 'VIEW_CALLS_BUTTON',
  ENFORCE_VOICE_GUARDRAILS = 'ENFORCE_VOICE_GUARDRAILS',
  CARRIER_OFFERS = 'CARRIER_OFFERS',
  USE_CLAUDE_FOR_CLASSIFICATION = 'USE_CLAUDE_FOR_CLASSIFICATION',
  USE_LLM_TO_SANITY_CHECK_VOICE_TOOL_CALLS = 'USE_LLM_TO_SANITY_CHECK_VOICE_TOOL_CALLS',
  SHOW_VOOMA_COVER_FOR_QUOTES = 'SHOW_VOOMA_COVER_FOR_QUOTES',
  INSIGHTS_V2_EMBEDS = 'INSIGHTS_V2_EMBEDS',
  CALL_INSIGHTS = 'CALL_INSIGHTS',
  SELF_SERVE_BUILD_INSTRUCTIONS = 'SELF_SERVE_BUILD_INSTRUCTIONS',
  ENABLE_BETA_TTS_MODELS = 'ENABLE_BETA_TTS_MODELS',
  SHIPMENT_LINKAGE_INSIGHTS = 'SHIPMENT_LINKAGE_INSIGHTS',
  TRACK_INSIGHTS = 'TRACK_INSIGHTS',
  ALLOW_CONVERSATION_WITHOUT_ACTION_EXECUTION = 'ALLOW_CONVERSATION_WITHOUT_ACTION_EXECUTION',
  FILTER_WHO_IS_CC_ED_GUARDRAIL = 'FILTER_WHO_IS_CC_ED_GUARDRAIL',
  ENABLE_GEOGRAPHIC_MATCHING = 'ENABLE_GEOGRAPHIC_MATCHING',
  RATE_SHIPMENT_ON_CREATE = 'RATE_SHIPMENT_ON_CREATE',
  USE_STANDALONE_VOICE_SERVICE = 'USE_STANDALONE_VOICE_SERVICE',
  ORDER_UPDATE_PIPELINE = 'ORDER_UPDATE_PIPELINE',
  DISABLE_AGENTIC_TRANSFERS = 'DISABLE_AGENTIC_TRANSFERS',
  PROCESS_INTEGRATIONLESS_SHIPMENTS = 'PROCESS_INTEGRATIONLESS_SHIPMENTS',
  USE_VOOMA_SPEECH_ANALYSIS = 'USE_VOOMA_SPEECH_ANALYSIS',
  ALLOW_GUARDRAIL_BYPASS = 'ALLOW_GUARDRAIL_BYPASS',
  USE_DFM_FULL_FLOW = 'USE_DFM_FULL_FLOW',
  SEND_MCLEOD_SUBJECT_ORDER = 'SEND_MCLEOD_SUBJECT_ORDER',
  FRONTEND_MAINTENANCE_MODE = 'FRONTEND_MAINTENANCE_MODE',
  DISABLE_ROUTE_SANITY_CHECK_IN_PUBLIC_API = 'DISABLE_ROUTE_SANITY_CHECK_IN_PUBLIC_API',
  DISABLE_PLACE_DATA_UPDATE_FROM_TMS_IMPORT = 'DISABLE_PLACE_DATA_UPDATE_FROM_TMS_IMPORT',
  ELIGIBLE_FOR_VOICE_EXPERIMENT = 'ELIGIBLE_FOR_VOICE_EXPERIMENT',
  USE_TRACK_MCLEOD_POST_DELIVERY_DEPARTURE_UPDATE = 'USE_TRACK_MCLEOD_POST_DELIVERY_DEPARTURE_UPDATE',
  BUILD_CONNECTED_SHIPMENTS_IN_INFLOW = 'BUILD_CONNECTED_SHIPMENTS_IN_INFLOW',
  AUTOMATICALLY_ASSOCIATE_ENTITIES_IN_AE_INPUTS = 'AUTOMATICALLY_ASSOCIATE_ENTITIES_IN_AE_INPUTS',
  SHOW_NEGOTIATION_STRATEGY_OVERRIDE = 'SHOW_NEGOTIATION_STRATEGY_OVERRIDE',
  INCLUDE_SHIPPER_IN_MOVEMENT_EVENT = 'INCLUDE_SHIPPER_IN_MOVEMENT_EVENT',
  GUMSHOE_ADMIN_UI = 'GUMSHOE_ADMIN_UI',
  FINISH_CONVERSATION_BUTTON = 'FINISH_CONVERSATION_BUTTON',
  // Temporary rollout switch for the DAT bulk-refresh task migration (ENG-8707).
  // Default off; flip per-org during rollout, then remove once we've confirmed
  // the bulk path is healthy in production.
  USE_DAT_BULK_REFRESH = 'USE_DAT_BULK_REFRESH',
  UPDATE_OUTLOOK_REPLY_SUBJECT = 'UPDATE_OUTLOOK_REPLY_SUBJECT',
  // NOTE(jonty): Kept so existing GraphQL clients can still send this flag name.
  // The layout gate is gone; the flag has no effect.
  AGENT_SIDE_PANEL = 'AGENT_SIDE_PANEL',
  // NOTE(jonty): Rollout switch for the hierarchical SOP list. Default off so
  // orgs keep the grid until we enable it per-org.
  SOP_LIST_VIEW = 'SOP_LIST_VIEW',
  // NOTE(jonty): Kept so existing GraphQL clients can still read this flag.
  // The legacy Track Settings page is gone; the new pages are always shown.
  TRACK_SETTINGS_PAGES = 'TRACK_SETTINGS_PAGES',
  // NOTE(jonty): Opt-out of the default DELIVERED skip. Existing orgs get
  // this enabled in admin (separate PR). New orgs stay off.
  CONTINUE_TRACKING_WHEN_DELIVERED = 'CONTINUE_TRACKING_WHEN_DELIVERED',
  TRANSFER_ON_COVERAGE_PLAN = 'TRANSFER_ON_COVERAGE_PLAN',
  SYNC_DAT_POSTING_ON_UPDATE = 'SYNC_DAT_POSTING_ON_UPDATE',
  TEAMS_CHANNEL_FILE_UPLOAD = 'TEAMS_CHANNEL_FILE_UPLOAD',
  CODE_DRIVEN_CARRIER_OUTREACH = 'CODE_DRIVEN_CARRIER_OUTREACH',
  // NOTE(jacob): Rollout switch for running Hosted McLeod location sync
  // in-process (clerk BullMQ worker) instead of the legacy vooma Lambda/SQS
  // path. Default off; flip per-org or per-originator during rollout.
  SYNC_HOSTED_MCLEOD_LOCATIONS_IN_CLERK = 'SYNC_HOSTED_MCLEOD_LOCATIONS_IN_CLERK',
  // NOTE(jonty): Rollout switch for the Track workspace page. Default off so
  // orgs keep the legacy Track page until we enable it per-org.
  TRACK_WORKSPACE_PAGE = 'TRACK_WORKSPACE_PAGE',
  // NOTE(jacob): Rollout switch for firing `*` email triggers at message insert
  // instead of after classification. Default off; flip per-org during rollout.
  EMAIL_TRIGGER_FAST_PATH = 'EMAIL_TRIGGER_FAST_PATH',
  // NOTE(jacob): Tracked syncs are parentless action executions, so they show
  // in the org's activity feed until that feed filters background tasks out.
  TRACK_INTEGRATION_ENTITY_SYNC = 'TRACK_INTEGRATION_ENTITY_SYNC',
  USE_STATEFUL_MCLEOD_SHIPMENT_POLLING = 'USE_STATEFUL_MCLEOD_SHIPMENT_POLLING',
  CHAT_SUGGESTIONS = 'CHAT_SUGGESTIONS',
  // NOTE(jonty): Rollout switch for the track SOP test dialog. Default off.
  TRACK_SOP_TEST = 'TRACK_SOP_TEST',
  // NOTE(cara): Rollout switch for the Track dashboard page. Default off.
  TRACK_DASHBOARD = 'TRACK_DASHBOARD',
  // NOTE(martin): Rollout switch for customer-triggered check calls, which
  // place real carrier calls on demand. Default off; enable per-org on request.
  TRACK_CUSTOMER_CHECK_CALL = 'TRACK_CUSTOMER_CHECK_CALL',
  // NOTE(jacob): Shows the Metronome usage and invoice dashboards before
  // billing is live. Default off.
  USAGE_DASHBOARD = 'USAGE_DASHBOARD',
  PRODUCT_COVER_SETTINGS = 'PRODUCT_COVER_SETTINGS',
  // NOTE(wassim): Lets Jev decide the NEW_ORDER class when an email's
  // classification is saved. Default off.
  JEV_NEW_ORDER_CLASSIFICATION = 'JEV_NEW_ORDER_CLASSIFICATION',
}
